import React from 'react';
import PropTypes from 'prop-types';
import {connect} from 'react-redux';
import bindAll from 'lodash.bindall';

import FoxbitUploadModalComponent from '../components/foxbit-upload-modal/foxbit-upload-modal.jsx';
import {closeFoxbitUploadModal} from '../reducers/modals';

class FoxbitUploadModal extends React.Component {
    constructor (props) {
        super(props);
        bindAll(this, [
            'handleCompile',
            'handleUpload'
        ]);
        this.state = {
            compileResult: null,
            uploadStatus: '',
            blockSummary: ''
        };
    }

    handleCompile () {
    if (window.foxbitExt && typeof window.foxbitExt.compile === 'function') {
        const result = window.foxbitExt.compile();
        
        let summary = '';
        if (result.blockSummary && result.blockSummary.length > 0) {
            summary = result.blockSummary.map(b => b.block || b.command).join('\n');
        }
        
        this.setState({
            compileResult: result,
            blockSummary: summary || '블록 요약 없음',
            uploadStatus: result.success ? '컴파일 완료!' : '컴파일 실패'
        });
     } else {
        this.setState({
            uploadStatus: 'FoxBit Extension을 찾을 수 없습니다'
        });
     }
   }

    handleUpload () {
        const {compileResult} = this.state;
        
        if (!compileResult || !compileResult.commands || compileResult.commands.length === 0) {
            this.setState({uploadStatus: '먼저 컴파일을 실행하세요'});
            return;
        }

        if (window.foxbitExt && typeof window.foxbitExt.upload === 'function') {
            this.setState({uploadStatus: '업로드 중...'});
            
            try {
                window.foxbitExt.upload(compileResult.commands);
                this.setState({uploadStatus: '업로드 완료!'});
            } catch (error) {
                this.setState({uploadStatus: `업로드 실패: ${error.message}`});
            }
        } else {
            this.setState({uploadStatus: 'FoxBit Extension을 찾을 수 없습니다'});
        }
    }

    render () {
        // ✅ 올바른 코드 (속성 접근)
        const isConnected = window.foxbitExt ? window.foxbitExt.isConnected : false;
        return (
            <FoxbitUploadModalComponent
                isConnected={isConnected}
                compileResult={this.state.compileResult}
                uploadStatus={this.state.uploadStatus}
                blockSummary={this.state.blockSummary}
                onClose={this.props.onClose}
                onCompile={this.handleCompile}
                onUpload={this.handleUpload}
            />
        );
    }
}

FoxbitUploadModal.propTypes = {
    onClose: PropTypes.func.isRequired
};

const mapDispatchToProps = dispatch => ({
    onClose: () => dispatch(closeFoxbitUploadModal())
});

export default connect(
    null,
    mapDispatchToProps
)(FoxbitUploadModal);